import { queryOptions } from '@tanstack/react-query';
import type { HevitonApiAppLegacy } from '@heviton/heviton-api-app-legacy';
import { USER_CONSENTS_QUERY_KEY } from '@/shared/api';
import { fromRawConsents } from '@/shared/data-mappers';
import type { UserConsent } from '@/shared/data-types';

/**
 * user 수신·마케팅 동의 query 정의 SSOT (queryKey + queryFn). `GET /users/me/consents`.
 * queryFn = BE 호출 → `fromRawConsents` 순수 변환. 검증 없음(계약 신뢰, ADR `domain-ssot` §5).
 */
export const userConsentsQueryOptions = (api: HevitonApiAppLegacy) =>
  queryOptions<UserConsent[]>({
    queryKey: USER_CONSENTS_QUERY_KEY,
    queryFn: async ({ signal }) => fromRawConsents(await api.user.getConsents({ signal })),
  });
